<div [ngClass]="{ dropdown_dd: true, open: isOpen }">
    <div class="dropdown_dd__header" (click)="handleDropdownClick()">
        {{ selectedItem.value }}
        <span class="dropdown_dd__header__icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="8px"
                viewBox="0 0 24 24"
                fill="none"
                stroke="rgba(255, 255, 255, 0.99)"
                stroke-linecap="round"
                stroke-width="3"
                stroke-linejoin="round">
                <path d="M2 6 L12 16 L22 6"></path></svg
        ></span>
    </div>
    <div class="dropdown_dd__radio">
        <div class="dropdown_dd__radio__item" *ngFor="let item of items | selectedFilter: selectedItem" (click)="handleItemClick(item)">
            {{ item.value }}
        </div>
    </div>
</div>
